import React from 'react';
import {concatenate} from "services/string";

type Props = {
    heading?: string
    subheading?: string
    action?: React.ReactNode
    dark?: boolean
    children: React.ReactNode
}

function Well(props: Props) {
    const {heading, subheading, action, dark, children} = props

    return (
        <div className={concatenate(dark? 'bg-gray-100' : 'bg-gray-50', 'shadow-sm sm:rounded-lg')}>
            {(heading || subheading || action) &&
                <div className={concatenate(heading && subheading? 'py-5' : 'pt-5 pb-2', 'px-4 sm:px-6 flex justify-between')}>
                    <h2 className="text-base leading-6 font-medium text-gray-900">
                        {heading}
                    </h2>
                    {subheading &&
                        <p className="mt-1 max-w-2xl text-sm text-gray-500">
                            {subheading}
                        </p>
                    }
                    {action}
                </div>
            }

            <div className="px-4 py-5 sm:p-6">
                {children}
            </div>
        </div>
    );
}

export default Well;